export const GET_COUNTRY = 'GET_COUNTRY'
export const LOAD_COUNTRY_REQUEST = 'LOAD_TODOS_REQUEST'
export const LOAD_COUNTRY_FAILURE = 'LOAD_TODOS_FAILURE'
export const LOAD_COUNTRY_SUCCESS = 'LOAD_TODOS_SUCCESS'
export const ADD_COUNTRIES_CART = 'ADD_COUNTRIES'
export const REMOVE_COUNTRIES_CART = 'REMOVE_COUNTRIES'
